<div class="accordion" id="accordionExample" style="margin-top: -25px;">


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Ingangsdatum & Einddatum
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld de datum waarop de fiscale instellingen beginnen. Bij het invullen van een einddatum kunnen de
                velden niet meer aangepast worden. Er kan dan wel een nieuwe regel toegevoegd worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Loonheffingskorting
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Loonheffingskorting: wat betekent dit?</b><br/>
                <strong>In het kort:</strong> De loonheffingskorting is een belastingvoordeel dat ervoor zorgt dat
                je minder loonheffing (belasting en premies) betaalt over je salaris. Het wordt automatisch door je
                werkgever toegepast op je loonstrook.
                <div class="space20"><!----></div>

                <b>Wat is loonheffingskorting precies?</b><br/>
                De loonheffingskorting is een korting op de loonheffing die je betaalt voor werk of uitkering. De
                loonheffingskorting is een korting op de loonheffing die je betaalt voor werk of uitkering. Door die
                korting betaal je dus minder loonheffing. De korting wordt direct verrekend met de belasting die je
                werkgever inhoudt op je loon, waardoor je een hoger nettosalaris op je rekening ontvangt.
                <div class="space20"><!----></div>
                Loonheffingskorting bestaat uit twee delen: de arbeidskorting en de algemene heffingskorting. De
                arbeidskorting is er voor werkenden ouder dan 18 jaar, de algemene heffingskorting is er voor iedereen.
                Voor de loonheffingskorting maakt het niet uit of je wel of geen fiscaal partner hebt:
                de loonheffingskorting is persoonsgebonden
                <div class="space20"><!----></div>

                <b>Op verzoek van de werknemer toepassen</b><br/>
                Elke werknemer die aan de voorwaarden van een of meer heffingskortingen voldoet, heeft recht op de
                loonheffingskorting. Je werknemer moet je schriftelijk vragen de loonheffingskorting toe te passen,
                bijvoorbeeld met het <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/programmas_en_formulieren/model_opgaaf_gegevens_voor_de_loonheffingen"
                    target="_blank">‘Model opgaaf gegevens voor de loonheffingen’</a>.

                <div class="space20"><!----></div>

                <b>Belangrijke aandachtspunt bij meerdere banen:</b><br>
                Zijn er meerdere werkgevers? Dan wordt de loonheffingskorting meestal alleen bij de
                hoofdbaan toegepast. Bij je bijbaan betaalt de werknemer vaak meer belasting, maar dit wordt
                gecorrigeerd in de jaarlijkse belastingaangifte.

                <div class="space20"><!----></div>

                <b>Hoeveel korting krijg je?</b><br/>
                De hoogte van je loonheffingskorting hangt af van verschillende factoren:
                <ul>
                    <li><strong>Je leeftijd:</strong> Ben je jonger dan de AOW-leeftijd? Dan krijg je meer
                        korting
                    </li>
                    <li><strong>Je inkomen:</strong> Hoe hoger je inkomen, hoe lager de korting wordt</li>
                    <li><strong>Het jaar:</strong> De bedragen worden jaarlijks aangepast</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Tabelkleur
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Witte en groene tabellen</b><br/>
                <p>In Nederland worden twee hoofdkleuren gebruikt voor loonbelastingtabellen:</p>

                <b>Witte Tabellen</b><br/>
                Als de werknemer loon ontvangt uit een tegenwoordige dienstbetrekking, dan pas je de witte
                loonbelastingtabellen toe.De witte tabellen worden gebruikt voor het reguliere maandloon van werknemers
                in dienst (lopende arbeidsrelaties).

                <b>Groene Tabellen</b>
                Als de werknemer loon ontvangt uit een vroegere dienstbetrekking, dan pas je de groene
                loonbelastingtabellen toe. De groene tabellen worden gebruikt voor:
                <ul>
                    <li>Bijzondere beloningen als bijvoorbeeld vakantiegeld en eindejaarsuitkering (bonus).</li>
                    <li>Bij ontslag geldt de transitievergoeding of ontslaguitkering als loon uit vroegere
                        dienstbetrekking. Voor de loonheffing maakt de werkgever gebruik van de groene tabel voor
                        bijzondere beloningen.
                    </li>
                    <li>Uitkeringen na beëindiging van het dienstverband</li>
                </ul>
                In deze groene tabel is geen arbeidskorting opgenomen, omdat deze korting bedoeld is voor
                werkenden.
                <div class="space20"><!----></div>

                <b>Let op</b>Wanneer een werkgever een werknemer deels loon geeft waarop de witte tabel en deels de
                groene tabel van toepassing zijn, is het niet toegestaan om dit in één inkomstenverhouding te verwerken.
                In dat geval heb je dus 2 of meer inkomstenverhoudingen (zie tabblad 'Dienstverband').

            </div>

            De Belastingdienst heeft de loonbelastingtabellen voor 2025 <a
                href="https://www.belastingdienst.nl/wps/wcm/connect/nl/personeel-en-loon/content/hulpmiddel-loonbelastingtabellen"
                target="_blank">online</a> gezet: de witte en groene
            loonbelastingtabellen 2025, de tabellen voor herleidingssituaties en de tabellen voor bijzondere
            beloningen.
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Jaarloon bijzonder tarief
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Jaarloon uitgangspunt voor de tabellen voor bijzondere beloningen</b><br/>
                Voor de tabellen voor bijzondere beloningen heb je een jaarloon nodig. Je baseert dit jaarloon op het
                loon
                uit kolom 14 van de loonstaat. De wijze waarop je dit jaar berekent vind je uitgebreid beschreven in het
                <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/handboek-loonheffingen"
                   target="_blank">Handboek Loonheffing</a> dat jaarlijks door de Belastingdienst beschikbaar gesteld
                wordt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Woonland fiscaal
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Op dit moment wordt binnen SnelStart Salaris alleen het woonland 'Nederland' ondersteund.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Herleidingssituatie
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Er zijn werknemers die op grond van internationaal recht geen belasting en/of premie volksverzekeringen
                in Nederland hoeven te betalen. Het gaat om werknemers in internationale situaties die:
                <ul>
                    <li>alleen loonbelasting moeten betalen</li>
                    <li>alleen premie volksverzekeringen moeten betalen</li>
                    <li>geen premie hoeven te betalen voor een of meer volksverzekeringen</li>
                </ul>
                Je mag als werkgever daarmee rekening houden. Je kunt dan gebruikmaken van de speciale
                herleidingstabellen. In een herleidingstabel zijn 1 of meer van de heffingen LB, premie AOW, Anw of Wlz
                geëlimineerd.

                In niet-internationale situaties kies je voor 'belasting- en premieplichtig (regulier).
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Anoniementarief
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het anoniementarief pas je toe in de volgende situaties:</p>

                <ul>
                    <li>Je werknemer heeft je zijn naam, adres, woonplaats of bsn niet verstrekt (vóór de 1e werkdag of
                        op de 1e werkdag als je op deze dag je werknemer aanneemt) (zie ook paragraaf 2.3.1).
                    </li>
                    <li>Je stelt de identiteit van je werknemer die loon uit tegenwoordige dienstbetrekking geniet niet
                        vast.
                    </li>
                    <li>Je bewaart deze gegevens niet of niet op de juiste manier bij je loonadministratie. Dit is
                        alleen van toepassing bij een werknemer die loon uit tegenwoordige dienstbetrekking geniet.
                    </li>
                    <li>Je weet dat je onjuiste gegevens van je werknemer hebt gekregen of je had dat kunnen weten.</li>
                    <li>Je werknemer heeft geen geldige verblijfs- of tewerkstellingsvergunning. Dit is alleen van
                        toepassing bij een werknemer die loon uit tegenwoordige dienstbetrekking geniet.
                    </li>
                </ul>

                <p>Bij loon uit vroegere dienstbetrekking (bijv. pensioen), dan pas je het anoniementarief toe als je
                    werknemer je zijn naam, adres, woonplaats of bsn niet heeft verstrekt, voordat je de eerste betaling
                    aan deze werknemer doet. Of als je weet dat je onjuiste gegevens van je werknemer hebt gekregen of
                    je had dat kunnen weten.</p>

                <p><strong>Als je het anoniementarief toepast, wordt er 52% loonbelasting/premie volksverzekeringen
                    ingehouden.</strong></p>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Incidentele inkomstenvermindering
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>De incidentele inkomstenvermindering betekent dat het loon in het
                    aangiftetijdvak lager is dan het loon dat je met je werknemer overeen bent gekomen. Op grond van
                    deze code zal UWV met dit lagere loon geen rekening houden bij het vaststellen van een uitkering. De
                    code geldt voor de volgende situaties:</p>

                <ul>
                    <li><strong>K</strong> Kindverlof</li>
                    <li><strong>O</strong> Onbetaald verlof</li>
                    <li><strong>S</strong> Stakingsdagen</li>
                    <li><strong>Z</strong> Ziekte</li>
                </ul>

                <p>Hieronder vind je een nadere toelichting op de diverse codes.</p>


                <p><strong>Let op</strong><br>
                    Je vult deze rubriek niet in als je 100% loon doorbetaalt, ook al is er sprake van een genoemde
                    situatie.</p>

                <p><strong>Let op</strong><br>
                    Bij een uitkering op grond van de Wet arbeid en zorg (WAZO) wegens zwangerschaps- en
                    bevallingsverlof, adoptie- of pleegzorgverlof mag je de codes K en O niet gebruiken.</p>

                <b>Meerdere inkomstenperioden</b><br/>

                <p>Zijn er in het aangiftetijdvak meerdere inkomstenperioden? Vul dan voor alle
                    inkomstenperioden altijd dezelfde code in, bijvoorbeeld:</p>

                <ul>
                    <li>De werknemer is in een aangiftetijdvak twee weken ziek, waardoor hij minder loon heeft
                        ontvangen. Je vult in alle inkomstenperioden van dat aangiftetijdvak code 'Z' in.
                    </li>
                    <li>De werknemer heeft aanvullend geboorteverlof, maar wordt op 21 maart ziek. Hij is hersteld op 15
                        april. In de maand maart geef je voor de hele aangifteperiode code 'K' op. In april geef je voor
                        de hele aangifteperiode code 'Z' op.
                    </li>
                </ul>

                <b>Toelichting op de verschillende codes</b><br/>

                <b>Code 'K' (Kindverlof)</b><br/>
                Je gebruikt deze code voor de volgende twee regelingen (waartegenover een uitkering op grond van de
                    Wet arbeid en zorg (WAZO) staat):
                <ul>
                    <li><strong>Het 'Aanvullend geboorteverlof'</strong><br>
                        'Aanvullendgeboorteverlof' is een tussen jou en je werknemer overeengekomen periode van
                        (onbetaald) verlof na bevalling van de partner. Dit aanvullend geboorteverlof geldt tot 2
                        augustus 2022 alleen voor werknemers die verzekerd zijn voor de werknemersverzekeringen. Vanaf 2
                        augustus geldt deze regeling ook voor niet-verzekerde werknemers.
                    </li>
                    <li><strong>Het 'Betaald ouderschapsverlof'</strong><br>
                        Deze regeling gaat in per 2 augustus 2022. 'Betaald ouderschapverlof' is een tussen jou en je
                        werknemer overeengekomen periode van verlof (voor een gedeelte of het geheel van de
                        arbeidstijd). Deze regeling geldt voor verzekerde en voor niet-verzekerde werknemers.
                    </li>
                </ul>

                <p><strong>Let op</strong><br>
                    Je vult de code 'K' alleen in als het totaal van het loon van je werknemer in het aangiftetijdvak
                    lager is dan het overeengekomen loon. Met 'loon' bedoelen wij het totaal van:</p>

                <ul>
                    <li>het reguliere loon,</li>
                    <li>de WAZO-uitkering die je namens UWV doorbetaalt (voor aanvullend geboorteverlof of voor betaald
                        ouderschapsverlof),
                    </li>
                    <li>een eventueel door jou verstrekte aanvulling op de WAZO-uitkering. Als je een aanvulling
                        verstrekt moet je deze ook vermelden in de rubriek 'Verstrekte aanvulling op uitkering
                        werknemersverzekeringen'.
                    </li>
                </ul>

                <b>Code 'O' (Onbetaald verlof)</b><br/>
                'Onbetaald verlof' in dit kader is een tussen jou en je werknemer voor een gedeelte of het geheel van
                    de arbeidstijd overeengekomen periode van verlof, waarin de werknemer geen arbeid voor jou verricht,
                    zoals: onbetaald ouderschapsverlof, zorgverlof en de Duurzame Inzetbaarheidsregeling voor ouderen in
                    het onderwijs.

                <br/><br/>

                <p><strong>Let op</strong><br>
                    Je vult geen code 'O' in:</p>

                <ul>
                    <li>als tegenover het lagere loon van je werknemer een WAZO-uitkering staat bij zwangerschaps- en
                        bevallingsverlof, adoptie- en pleegzorgverlof. In deze situaties geldt geen code.
                    </li>
                    <li>als tegenover het lagere loon van je werknemer een WAZO-uitkering staat bij aanvullend
                        geboorteverlof of onbetaald ouderschapsverlof. Je gebruikt code 'K' (zie hiervóór).
                    </li>
                    <li>bij verlof wegens vakantie als in het loon over de vakantieperiode volledig is voorzien door een
                        regeling voor tijdsparen, zie paragraaf 21.2.2. In deze situatie geldt geen code. Je vult dan
                        wel de rubriek 'Indicatie vakantiebonnen toegepast' in.
                    </li>
                </ul>

                <b>Code 'S' (Stakingsdagen)</b><br/>
                Staking in dit kader is het tijdelijk niet verrichten van de bedongen arbeid als dwangmiddel ter
                    bereiking van een bepaald doel. Voor dit begrip is er geen onderscheid of het een georganiseerde of
                    wilde staking is, noch of er sprake is van een lidmaatschap van een vakbond of van betaling uit de
                    stakingskas.

                <b>Code 'Z' (Ziekte)</b><br/>
                <p>Ziekte is in dit kader een beperking in de lichamelijke of geestelijke gezondheid van de werknemer
                    waardoor hij niet in staat is om zijn arbeid te verrichten.</p>

                <p><strong>Let op</strong><br>
                    Je vult code 'Z' niet in als tegenover het lagere loon van je werknemer (recht op) een uitkering op
                    grond van de Ziektewet, de Wet Werk en Inkomen naar Arbeidsvermogen of de Wet op de
                    arbeidsongeschiktheidsverzekering staat. Ook niet als die uitkering niet voorziet in het volledige
                    overeengekomen loon.</p>

                <p>Als er sprake is van een uitkering op grond van de Ziektewet, waarop je een aanvulling verstrekt, dan
                    moet je deze aanvulling, zolang de dienstbetrekking nog niet is beëindigd, ook vermelden in de
                    rubriek 'Verstrekte aanvulling op uitkering werknemersverzekeringen'.</p>
        </div>
    </div>
</div>
</div>

